// src/pages/StatePage.js
import { useParams } from "react-router-dom";

export default function StatePage() {
  const { stateId } = useParams();
  return (
    <div style={{ padding: "2rem" }}>
      <h2>State Page</h2>
      <p>Details for state ID: {stateId}</p>
    </div>
  );
}
